import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { BudgetimportComponent } from './budgetimport.component';

const routes: Routes = [{ path: '', component: BudgetimportComponent,pathMatch:'full'  }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class BudgetimportRoutingModule { }
